var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342.38,
    height: 59.772,
    viewBox: "0 0 342.38 59.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.1 -12.897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.468 36.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.825,50.548,148,69.618l7.16-19.07h5.588v24.88h-4.306v-8.2l.427-10.97-7.348,19.173h-3.093L139.1,56.272l.427,10.953v8.2H135.22V50.548Z",
    transform: "translate(-135.22 -49.181)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.259,67.569a10.9,10.9,0,0,1,1.077-4.9,7.864,7.864,0,0,1,3.025-3.349,8.526,8.526,0,0,1,4.477-1.171,8.076,8.076,0,0,1,6.075,2.409,9.48,9.48,0,0,1,2.52,6.391l.017.974a11,11,0,0,1-1.051,4.887,7.77,7.77,0,0,1-3.007,3.332,8.586,8.586,0,0,1-4.52,1.179,8.018,8.018,0,0,1-6.263-2.606,9.977,9.977,0,0,1-2.35-6.946Zm4.152.359A7.449,7.449,0,0,0,177.59,72.4a3.833,3.833,0,0,0,3.281,1.615,3.792,3.792,0,0,0,3.272-1.64,8.232,8.232,0,0,0,1.171-4.8,7.355,7.355,0,0,0-1.2-4.443,4.061,4.061,0,0,0-6.5-.026A8.072,8.072,0,0,0,176.411,67.928Z",
    transform: "translate(-142.799 -50.737)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,66.02a11.106,11.106,0,0,1-1.922,6.852,6.261,6.261,0,0,1-5.289,2.546,6.029,6.029,0,0,1-5.058-2.341l-.205,2h-3.759V48.829h4.152v9.535a6.011,6.011,0,0,1,4.836-2.119,6.334,6.334,0,0,1,5.314,2.512,11.292,11.292,0,0,1,1.931,7.023Zm-4.152-.359A7.853,7.853,0,0,0,209.3,61.15a3.53,3.53,0,0,0-3.076-1.5A3.854,3.854,0,0,0,202.429,62v7.621a3.9,3.9,0,0,0,3.828,2.409,3.5,3.5,0,0,0,3.007-1.452,7.61,7.61,0,0,0,1.094-4.392Z",
    transform: "translate(-148.123 -48.829)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.069,51.974a2.2,2.2,0,0,1,.607-1.589,2.292,2.292,0,0,1,1.734-.632,2.322,2.322,0,0,1,1.743.632,2.188,2.188,0,0,1,.615,1.589,2.136,2.136,0,0,1-.615,1.564,2.336,2.336,0,0,1-1.743.624,2.306,2.306,0,0,1-1.734-.624A2.151,2.151,0,0,1,223.069,51.974Zm4.409,23.291h-4.152V56.776h4.152Z",
    transform: "translate(-153.197 -49.018)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.78,75.076h-4.152V48.829h4.152Z",
    transform: "translate(-155.562 -48.829)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.369,58.5l.12,2.136a6.649,6.649,0,0,1,5.383-2.478q5.775,0,5.878,6.613V76.984H256.6V65.006a3.811,3.811,0,0,0-.76-2.606,3.2,3.2,0,0,0-2.486-.846,4,4,0,0,0-3.742,2.273V76.984h-4.152V58.5Z",
    transform: "translate(-157.778 -50.737)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.552,75.107H270.4V56.618h4.152Zm-.786-26.127H278.5l-4.733,5.178-3.332-.009Z",
    transform: "translate(-162.882 -48.86)",
    fill: "#e9b847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.664,71.96a1.884,1.884,0,0,0-.914-1.692,9.757,9.757,0,0,0-3.033-1.025,15.558,15.558,0,0,1-3.537-1.128q-3.111-1.5-3.11-4.357a4.921,4.921,0,0,1,2.016-4,7.972,7.972,0,0,1,5.126-1.606,8.3,8.3,0,0,1,5.357,1.64,5.207,5.207,0,0,1,2.042,4.255h-4.152a2.561,2.561,0,0,0-.889-1.991,3.406,3.406,0,0,0-2.358-.795,3.681,3.681,0,0,0-2.23.632,1.993,1.993,0,0,0-.863,1.692,1.681,1.681,0,0,0,.8,1.487,11.027,11.027,0,0,0,3.247,1.068,15.379,15.379,0,0,1,3.836,1.282,5.443,5.443,0,0,1,2.068,1.786,4.557,4.557,0,0,1,.675,2.529,4.818,4.818,0,0,1-2.068,4.041,8.815,8.815,0,0,1-5.417,1.546,9.559,9.559,0,0,1-4.05-.82,6.659,6.659,0,0,1-2.768-2.256,5.337,5.337,0,0,1-.991-3.093h4.033a2.924,2.924,0,0,0,1.111,2.264,4.316,4.316,0,0,0,2.717.795,4.2,4.2,0,0,0,2.495-.624A1.93,1.93,0,0,0,302.664,71.96Z",
    transform: "translate(-167.191 -50.737)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.235,67.147l-1.845,1.9v6.032h-4.152V48.829h4.152v15.14l1.3-1.623,5.109-5.759h4.99l-6.869,7.707,7.6,10.782h-4.8Z",
    transform: "translate(-172.058 -48.829)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.679,75.076h-4.152V48.829h4.152Z",
    transform: "translate(-176.824 -48.829)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.325,76.984a6.393,6.393,0,0,1-.478-1.726,6.985,6.985,0,0,1-9.4.478,5.083,5.083,0,0,1-1.76-3.93,5.25,5.25,0,0,1,2.2-4.537,10.643,10.643,0,0,1,6.28-1.581h2.546V64.476a3.24,3.24,0,0,0-.8-2.3,3.186,3.186,0,0,0-2.444-.863,3.659,3.659,0,0,0-2.324.709,2.195,2.195,0,0,0-.906,1.8h-4.152a4.606,4.606,0,0,1,1.008-2.845,6.722,6.722,0,0,1,2.743-2.076,9.635,9.635,0,0,1,3.87-.752,7.763,7.763,0,0,1,5.178,1.632,5.821,5.821,0,0,1,1.982,4.588v8.339a9.441,9.441,0,0,0,.7,3.981v.29Zm-4.562-2.99a4.719,4.719,0,0,0,2.315-.6,4,4,0,0,0,1.632-1.606V68.3h-2.239a6.123,6.123,0,0,0-3.469.8,2.6,2.6,0,0,0-1.162,2.273,2.426,2.426,0,0,0,.795,1.905A3.076,3.076,0,0,0,355.763,73.994Z",
    transform: "translate(-178.903 -50.737)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.257,65.695a10.99,10.99,0,0,1,1.982-6.861,6.351,6.351,0,0,1,5.314-2.589A6.036,6.036,0,0,1,384.3,58.3V48.829h4.152V75.076H384.7l-.205-1.914a6.122,6.122,0,0,1-4.973,2.256,6.315,6.315,0,0,1-5.255-2.614A11.391,11.391,0,0,1,372.257,65.695Zm4.152.359a7.691,7.691,0,0,0,1.085,4.4,3.52,3.52,0,0,0,3.084,1.581,3.921,3.921,0,0,0,3.725-2.273V61.867a3.863,3.863,0,0,0-3.691-2.221,3.546,3.546,0,0,0-3.11,1.6A8.57,8.57,0,0,0,376.409,66.054Z",
    transform: "translate(-183.726 -48.829)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.908,58.5l.12,2.136a6.649,6.649,0,0,1,5.383-2.478q5.775,0,5.878,6.613V76.984h-4.152V65.006a3.811,3.811,0,0,0-.76-2.606,3.2,3.2,0,0,0-2.486-.846,4,4,0,0,0-3.742,2.273V76.984H398V58.5Z",
    transform: "translate(-188.993 -50.737)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.091,75.107h-4.152V56.618h4.152ZM426.3,48.98h4.733L426.3,54.157l-3.332-.009Z",
    transform: "translate(-194.098 -48.86)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.108,67.147l-1.845,1.9v6.032H434.11V48.829h4.152v15.14l1.3-1.623,5.109-5.759h4.99l-6.869,7.707,7.6,10.782h-4.8Z",
    transform: "translate(-196.384 -48.829)",
    fill: "#cd9b33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.1 11.897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.146,63.437H62.1V29.629L36.842,12.354,11.58,29.629V63.437H4.537V26.03l32.3-22.365,32.3,22.365Z",
    transform: "translate(-4.537 -2.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.752,76.183h18.56V91.758H24.752Z",
    transform: "translate(-12.343 -31.053)",
    fill: "#cd9b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.565,76.183h18.56V91.758H59.565Z",
    transform: "translate(-25.785 -31.053)",
    fill: "#9c762c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.752,46.869h18.56V62.444H24.752Z",
    transform: "translate(-12.343 -19.734)",
    fill: "#e9b847"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5aca9d081dd6415d6beba930368f2f52.svg";
export { ForwardRef as ReactComponent };